import { useLocalization } from "@fluent/react";
import { Button, IconButton } from "@narmi/design_system";
import type MembershipType from "byzantine/src/Membership";
import { Dialog, useLoadingContext, useNotificationContext } from "cerulean";
import { ReactNode, useState } from "react";
import styles from "./MembershipInfoRow.module.scss";

interface MembershipInfoRowProps {
  name: ReactNode;
  membership: MembershipType;
  removeMembership?: CallableFunction;
}
const MembershipInfoRow = ({
  name,
  membership,
  removeMembership,
}: MembershipInfoRowProps) => {
  const { l10n } = useLocalization();
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const { setIsLoading } = useLoadingContext();
  const { sendNotification } = useNotificationContext();

  const handleDelete = () => {
    setIsLoading(true);
    membership
      .delete()
      .then(() => {
        setDeleteModalOpen(false);
        setIsLoading(false);
        sendNotification({
          type: "success",
          text: l10n.getString("message-account-unlinked"),
        });
        removeMembership?.(membership.id);
      })
      .catch((err: string) => {
        setIsLoading(false);
        sendNotification({
          type: "negative",
          text: err,
        });
      });
  };

  return (
    <>
      <div className={styles["membership-info-row"]}>
        <span className={styles.left}>{name}</span>
        <span className={styles.right}>
          <div className={styles["membership-id"]}>{membership.id}</div>
          {removeMembership && (
            <IconButton
              kind="plain"
              label={l10n.getString("button-edit")}
              name="trash-2"
              onClick={() => setDeleteModalOpen(true)}
            />
          )}
        </span>
      </div>
      <Dialog
        isOpen={deleteModalOpen}
        footer={
          <div style={{ textAlign: "right" }}>
            <Button kind="negative" onClick={() => setDeleteModalOpen(false)}>
              {l10n.getString("button-cancel")}
            </Button>
            <span className="margin--left--s">
              <Button onClick={handleDelete}>{l10n.getString("button-unlink-account")}</Button>
            </span>
          </div>
        }
        onUserDismiss={() => setDeleteModalOpen(false)}
        title={l10n.getString("dialog-unlink-account-title")}
      >
        <div>{l10n.getString("dialog-unlink-account-description")}</div>
      </Dialog>
    </>
  );
};

export default MembershipInfoRow;
